import { FormikProps } from "formik";
import { getFormikErrorMessage } from "../../utils/AppFunctions";
import { ICDropDown } from "../form/index";
import { cn } from "../../lib";
import { IOption } from "../../data/AppInterface";

interface ICustomFormikDropDown<T> extends FormikProps<T> {
  name: keyof T;
  placeholder: string;
  options: IOption<string>[];
  containerClassName?: string;
}

const ICFormikDropDown = <T extends Object>(
  props: ICustomFormikDropDown<T>
) => {
  const { touched, errors, values, setFieldValue } = props;
  const { name, placeholder, containerClassName, options } = props;
  const fieldName = props.name as string;

  return (
    <div className={cn({ [`${containerClassName}`]: containerClassName })}>
      <span className="block mb-2">{placeholder}</span>
      <ICDropDown<string>
        options={options}
        selected={values[name] as string}
        onSelect={(option) => setFieldValue(fieldName, option.data_value)}
      />
      {touched[name] && errors[name] && (
        <span className="w-full">
          {getFormikErrorMessage<T>(errors, touched, name)}
        </span>
      )}
    </div>
  );
};

export default ICFormikDropDown;
